<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "AppProductInfo",

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    ...mapGetters(["mainLoading", "langs"]),
    ...mapState("Orders", {
      order: (state) => state.order.model,
      orderLoading: (state) => state.order.loading,
    }),

    /**
     * Verifica se as varições podem ser exibidas baseado nas seguintes regras
     *
     * - Não pode ser a pagina de avaliação
     * - Precisa existir alguma variação no produto
     *
     * @return {boolean}
     */
    shouldShowVariations() {
      return (
        this.$route.name !== "orders.rating" && this.product.sku?.length > 0
      );
    },

    /**
     * Verifica se deve exibir a label de embalagem de presente.
     * @return {boolean}
     */
    shouldShowGiftWrapLabel() {
      const giftWrapList = this.order?.extensions?.GiftWrap || [];

      if (giftWrapList.length === 0) {
        return false;
      }

      return !!giftWrapList.find(
        (gitWrapItem) => gitWrapItem.product_id == this.product.id
      );
    },

    /**
     * Verifica se deve exibir a label de cupom presente.
     * @return {boolean}
     */
    shouldShowGiftCouponLabel() {
      return this.product?.is_giveaway_by_coupon === true;
    },
  },
};
</script>

<template>
  <div class="app__order-products__product-details">
    <span
      class="app__order-products__product-name"
      :class="{ app__loading: loading }"
    >
      <template v-if="product.url">
        <a
          class="app__link"
          :href="product.url.https"
          :title="`Ir para ${product.name}`"
          target="_blank"
        >
          {{ product.name }}
        </a>
      </template>
      <template v-else>
        {{ product.name }}
      </template>
      <div class="app__order-products__gift-wrap-container">
        <span
          v-show="shouldShowGiftWrapLabel"
          data-test="gift-wrap-label"
          class="app__order-products__gift-wrap-label badge badge-secondary"
          :class="{ app__loading: loading }"
        >
          {{ this.langs.product["gift-wrap-label"] }}
        </span>
        <span
          v-show="shouldShowGiftCouponLabel"
          data-test="gift-coupon-label"
          class="app__order-products__gift-coupon-label badge badge-giveaway-by-coupon"
          :class="{ app__loading: loading }"
        >
          {{ this.langs.product["gift-coupon-label"] }}
        </span>
      </div>
    </span>

    <div
      v-if="shouldShowVariations"
      class="app__order-products__product-variations"
    >
      <span
        class="app__order-products__product-variation"
        :class="{ app__loading: loading }"
        v-for="(variation, variationIndex) in product.sku"
        :key="variationIndex"
        :data-test="`variant-${variation.type.toLowerCase()}`"
      >
        {{ variation.type }}: {{ variation.value }}
      </span>
    </div>
  </div>
</template>
